import { useTranslation } from "react-i18next";
import UserProfilePictureAvatar from "../../avatar/UserProfilePictureAvatar";
import { Moment } from "moment";
import { classNames } from "../../../helpers";
import { ExclamationIcon } from "@heroicons/react/outline";

type StartableRoomCardBaseProps = {
  profilePictureUrl?: string;
  participantName: string;
  sessionStatusText: string;
  telawahName: string;
  sessionNumber: number;
  sessionStartTime: Moment;
};

export default function AbsenceRoomCard(props: StartableRoomCardBaseProps) {
  const { t } = useTranslation("", { keyPrefix: "page.tutor.dashboard.room" });
  const {
    profilePictureUrl,
    participantName,
    telawahName,
    sessionStatusText,
    sessionNumber,
    sessionStartTime,
  } = props;

  const bgColor = "bg-[#F3F4F6]";
  const titleTextColor = "text-[#1F2937]";
  const subtitleTextColor = "text-[#1F2937]";
  const border = "border border-[#D1D5DB]"
  return (
    <div
      className={classNames(
        `divide-y sm:divide-y-0 rounded-lg shadow-md p-4 flex gap-4 sm:justify-between flex-col sm:flex-row w-auto sm:w-full mx-auto sm:mx-0`,
        bgColor,
        border,
        titleTextColor
      )}
    >
      {/* start reader info */}
      <div className="flex items-center gap-3 pe-4">
        <UserProfilePictureAvatar
          profilePictureUrl={profilePictureUrl}
          className="w-10 h-10"
          alt="sand-user-img"
        />

        <div className="flex items-start gap-1 flex-col">
          <h3 className={`text-sm font-medium`}>{participantName}</h3>
          <p className={`text-sm font-normal ${subtitleTextColor}`}>
            {telawahName}
          </p>
          <h3 className={`text-sm font-medium md:hidden`}>
            {sessionStatusText}
          </h3>
        </div>
      </div>
      {/* end reader info */}
      {/* start session info */}
      <div className="pt-1 md:pt-0 md:pe-4 h-full   md:mt-2">
        <div className="flex items-center">
          <p className={"font-medium text-base"}>
            {t("sessionNum", { num: "# " + sessionNumber })}
          </p>
        </div>
      </div>
      {/* end session info */}
      {/* start session time */}
      <div
        className="pe-4 flex justify-center sm:static "
        data-cy="startSessionContainer"
      >
        <div className="flex md:items-start gap-4 md:gap-1 flex-row md:flex-col items-center">
          <div className="   flex items-center   font-normal text-[#DC2626]">
            <ExclamationIcon className=" text-[#DC2626] w-5 h-5" />
            <p className="text-sm  font-medium ">{t("absence")}</p>
          </div>
          <h3 className="text-xs text-[#9CA3AF]   font-normal ">
            {t("sessionTimeDtls", {
              time:
                sessionStartTime.format("hh:mm") +
                " " +
                sessionStartTime.format("A"),
            })}
          </h3>
        </div>
      </div>
      {/* end session time */}
    </div>
  );
}
